class RyderMarquee {
  constructor(el, direct) {
    this.hero = $(el).parent().get(0);
    this.wrapper = el;
    this.delta = 0;
    this.transform = 0;
    this.step = 1;
    this.direct = direct % 1;
    if (this.direct == 1) {
      this.wrapper.style.transform = `translate3d(-${
        this.wrapper.getBoundingClientRect().width / 2
      }px, 0, 0)`;
      this.transform = -this.wrapper.getBoundingClientRect().width / 2;
    }
  }
  animate() {
    this.transform += this.step;
    if (this.direct == 1) {
      if (this.transform > 0) {
        this.transform = -this.wrapper.getBoundingClientRect().width / 2;
      }
      this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
    } else {
      if (this.transform > this.wrapper.getBoundingClientRect().width / 2) {
        this.transform = 0;
      }
      this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
    }
  }
  render() {
    this.scrollY = $(window).scrollTop();
    const bounding = this.hero.getBoundingClientRect();
    const distance =
      window.innerHeight + this.scrollY - (bounding.top + this.scrollY);
    const percentage =
      distance / ((window.innerHeight + bounding.height) / 100);
    if (percentage > 0 && percentage < 100) {
      this.animate();
    }
  }
  create() {
    gsap.ticker.add(this.render.bind(this));
  }
}
class RyderMarqueetoRight {
  constructor(el, direct) {
    this.hero = $(el).parent().get(0);
    this.wrapper = el;
    this.delta = 0;
    this.transform = 0;
    this.step = 1;
    this.direct = direct % 1;
    if (this.direct == 1) {
      this.wrapper.style.transform = `translate3d(${
        this.wrapper.getBoundingClientRect().width / 2
      }px, 0, 0)`;
      this.transform = this.wrapper.getBoundingClientRect().width / 2;
    }
  }
  animate() {
    this.transform += this.step;
    if (this.direct == 1) {
      if (this.transform > 0) {
        this.transform = this.wrapper.getBoundingClientRect().width / 2;
      }
      this.wrapper.style.transform = `translate3d(${this.transform}px, 0, 0)`;
    } else {
      if (this.transform > this.wrapper.getBoundingClientRect().width / 2) {
        this.transform = 0;
      }
      this.wrapper.style.transform = `translate3d(${this.transform}px, 0, 0)`;
    }
  }
  render() {
    this.scrollY = $(window).scrollTop();
    const bounding = this.hero.getBoundingClientRect();
    const distance =
      window.innerHeight + this.scrollY - (bounding.top + this.scrollY);
    const percentage =
      distance / ((window.innerHeight + bounding.height) / 100);
    if (percentage > 0 && percentage < 100) {
      this.animate();
    }
  }
  create() {
    gsap.ticker.add(this.render.bind(this));
  }
}

$(".marquee").each(function (i, el) {
  var $copy = $(el).contents().clone();
  $(el).append($copy);
  var ryderMarquee = new RyderMarquee(el, i).create();
});

$(".marquee-right").each(function (i, el) {
  var $copy = $(el).contents().clone();
  $(el).append($copy);
  var ryderMarqueetoRight = new RyderMarqueetoRight(el, i).create();
});

$(window)
  .on("resize", function () {
    if ($(this).width() > 1025) {
      if (window.device == "mobile") {
        location.reload();
      }
      window.device = "desktop";
    } else {
      if (window.device == "desktop") {
        location.reload();
      }
      window.device = "mobile";
    }
  })
  .trigger("resize");

$("[data-r]").each(function (i, el) {
  if (device == "mobile" && $(el).data("mobile-r") != undefined) {
    var _p = $(el).data("mobile-r");
  } else {
    var _p = $(el).data("r");
  }

  var _st_default = {
    trigger: el,
    start: "top 80%",
    end: "bottom 0%",
    toggleActions: "play none play none",
    // markers: true,
  };

  var _st = Object.assign(_st_default, _p.scrollTrigger);

  var _t = $(el).offset().top;
  var _hook = ($(window).height() * _st.start.replace(/[^0-9]/g, "")) / 100;

  if (_t <= _hook) {
    _p.delay = _p.delay != undefined ? (_p.delay += 1) : 1;
  }

  delete _p.scrollTrigger;

  var _setting = {
    scrollTrigger: _st,
    duration: 1.2,
    // opacity: 0,
    ease: "power2.out",
  };

  if (_p != "" && "stagger" in _p) {
    var $el = $(el).children();
  } else {
    var $el = el;
  }

  var _obj = Object.assign(_setting, _p);

  gsap.from($el, _obj);
});

$("#preload").delay(500).fadeOut(500);

$("[data-share]").each((i, el) => {
  var type = el.dataset.share;
  $(el).click(function (e) {
    e.preventDefault();

    var winHeight = 360;
    var winWidth = 600;
    var winTop = screen.height / 2 - winHeight / 2;
    var winLeft = screen.width / 2 - winWidth / 2;
    var url = $(this).attr("href");

    if (type == "facebook") {
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "twitter") {
      window.open(
        "https://twitter.com/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "pinterest") {
      window.open(
        "https://www.pinterest.com/pin/create/button/?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "googleplus") {
      window.open(
        "https://plus.google.com/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "linkedin") {
      window.open(
        "https://www.linkedin.com/cws/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "weibo") {
      window.open(
        "https://service.weibo.com/share/share.php?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "line") {
      window.open("https://line.naver.jp/R/msg/text/?" + url);
    } else if (type == "instagram") {
      window.open("https://www.instagram.com/?url=" + url);
    }
  });
});

$("#preload").delay(500).fadeOut(500);

// $("nav .cat").on("click", function () {
//   $(".topmenuListWrap").addClass("is-show");
//   $('html').addClass('is-lock')
//   $('body').addClass('is-lock')
//   if (window.device == 'mobile') {
//     $('.topmenu .catWrap .text').text('CLOSE')
//   }
// });

// $(".topmenuListWrap .close").on("click", function () {
//   $(".topmenuListWrap").removeClass("is-show");
//   $('html').removeClass('is-lock')
//   $('body').removeClass('is-lock')
//   if (window.device == 'mobile') {
//     $("nav .cat").removeClass()
//     $('.topmenu .catWrap .text').text('MENU')
//   }
// });

if (window.device == "desktop") {
  $("nav .cat").on("click", function () {
    $(".topmenuListWrap").addClass("is-show");
    $("html").addClass("is-lock");
    $("body").addClass("is-lock");
    if (window.device == "mobile") {
      $(".topmenu .catWrap .text").text("CLOSE");
    }
  });

  $(".topmenuListWrap .close").on("click", function () {
    $(".topmenuListWrap").removeClass("is-show");
    $("html").removeClass("is-lock");
    $("body").removeClass("is-lock");
  });
} else {
  $("nav .catWrap").on("click", function () {
    if ($(".topmenuListWrap").hasClass("is-show")) {
      $(".topmenuListWrap").removeClass("is-show");
      $("html").removeClass("is-lock");
      $("body").removeClass("is-lock");
      $(".topmenu .catWrap .text").text("MENU");
      $("nav .catWrap").removeClass("close");
      $("nav .catWrap").addClass("menu");
    } else {
      $(".topmenuListWrap").addClass("is-show");
      $("html").addClass("is-lock");
      $("body").addClass("is-lock");
      $(".topmenu .catWrap .text").text("CLOSE");
      $("nav .catWrap").removeClass("menu");
      $("nav .catWrap").addClass("close");
    }
  });

  // $("nav .catWrap.menu-close").on("click", function () {

  // });
}
if (window.device == "desktop") {
  $(".topmenuList li").each(function (i, el) {
    $(el).hover(
      function () {
        // $(this).removeClass("is-change");
        $(this).addClass("is-hover").siblings().addClass("is-change");
      },
      function () {
        $(this).removeClass("is-hover").siblings().removeClass("is-change");
      }
    );
  });
} else {
  $(".topmenuList li").each(function (i, el) {
    $(el).on("click", function () {
      // $(this).removeClass("is-change");
      $(this).addClass("is-hover").siblings().addClass("is-change");
    });
  });
}

if (window.device == "desktop") {
  const slides = document.querySelectorAll(
    ".topmenuListWrap .cat-area.show-for-large .cat"
  );
  let currentIndex = 0;
  setInterval(() => {
    // 移除目前所有 active 類別
    slides.forEach((slide) => slide.classList.remove("is-show"));

    // 顯示目前要顯示的那張
    slides[currentIndex].classList.add("is-show");

    // 計算下一張 index
    if (currentIndex >= 4) {
      currentIndex == 0;
    } else {
      currentIndex = (currentIndex + 1) % slides.length;
    }
  }, 3000);
} else {
  const slides = document.querySelectorAll(
    ".topmenuListWrap .cat-area.hide-for-large .cat"
  );
  let currentIndex = 0;
  setInterval(() => {
    // 移除目前所有 active 類別
    slides.forEach((slide) => slide.classList.remove("is-show"));

    // 顯示目前要顯示的那張
    slides[currentIndex].classList.add("is-show");

    // 計算下一張 index
    if (currentIndex >= 3) {
      currentIndex == 0;
    } else {
      currentIndex = (currentIndex + 1) % slides.length;
    }
  }, 3000);
}
let $tl_footer = gsap
  .timeline({
    paused: true,
  })
  .to("footer .c", {
    duration: 0.75,
    y: 0,
    ease: Power2.easeOut,
  })
  .to(
    "footer .m",
    {
      duration: 0.75,
      y: 0,
      ease: Power2.easeOut,
    },
    "<0"
  );

let $tl_footer_cat = gsap
  .timeline({
    paused: true,
  })
  .to("footer .info-area", {
    duration: 0.75,
    opacity: 1,
    ease: Power2.easeOut,
  })
  .to(
    "footer .cat-area",
    {
      duration: 0.75,
      opacity: 1,
      ease: Power2.easeOut,
    },
    "<0"
  )
  .to("footer .cat-area .title", {
    duration: 1,
    clipPath: 'path("M0 0 H237 V119.48 H0 Z")',
    ease: Power2.easeOut,
  })
  .to(
    "footer .cat-area .cat",
    {
      duration: 0.75,
      opacity: 1,
      x: 0,
      ease: Power2.easeOut,
    },
    "<0.75"
  );
// ScrollTrigger.create({
//   trigger: "footer",
//   toggleActions: "play pause pause pause", //重覆觸發
//   start: "top 40%",
//   end: "80% 40%",
//   // markers: true,
//   animation: $tl_footer,
//   scrub: 1,
//   // onEnter() {
//   // },
// });
if (window.device == "desktop") {
  ScrollTrigger.create({
    trigger: "footer",
    toggleActions: "play pause pause pause", //重覆觸發
    start: "top 60%",
    end: "bottom 60%",
    // markers: true,
    onEnter() {
      $tl_footer_cat.play();
    },
  });
} else {
  ScrollTrigger.create({
    trigger: "footer",
    toggleActions: "play pause pause pause", //重覆觸發
    start: "top center",
    end: "bottom center",
    // markers: true,
    onEnter() {
      $tl_footer_cat.play();
    },
  });
}

if (window.device == "desktop") {
  let point = document.getElementById("cursor");
  document.addEventListener("mousemove", function (e) {
    point.style.left = e.pageX + -14 + "px";
    point.style.top = e.pageY - window.scrollY + -12.5 + "px";
  });
}
